const capitalizeFirstLetter = (input: string | '') => {
  return input.charAt(0).toUpperCase() + input.slice(1);
};

const isString = (data: any): boolean => {
  let value = true;
  if (typeof data !== 'string' || data === null || data === undefined) {
    value = false;
  }
  return value;
};

/**
 * Obtiene el valor de un string, en caso de no ser string, se obtiene el valor de alternativo
 * @param data - any - Valor a obtener y validar
 * @param alternativo - string - (OPCIONAL) Valor alternativo en caso de no ser string
 * @returns string - Valor de la cadena de texto
 */
const getStringValue = (data: any, alternativo: string = '') => {
  let value = '';

  if (isString(data)) {
    value = data;
  } else {
    value = getStringValue(alternativo, '');
  }

  return value;
};

/**
 * Obtiene el valor de un string, en caso de no ser string, se obtiene el valor de alternativo o vacio
 * @param data - any - Valor a obtener y validar
 * @param alternativo - string - (OPCIONAL) Valor alternativo en caso de no ser string
 * @returns string - Valor de la cadena de texto
 */
const getStringValueNoEmpty = (data: any, alternativo: string = '') => {
  let value = '';
  
  if (getStringValue(data) !== '') {
    value = data;
  } else {
    if (getStringValueNoEmpty(alternativo) !== '') {
      value = getStringValue(alternativo);
    }
  }

  return value;
};

/**
 * Verifica si el string es vacio
 * @param data - any - Valor a verificar
 * @returns boolean - true si el string es vacio, false en caso contrario
 */
const isEmptyString = (data: string): boolean => {
  return getStringValueNoEmpty(data) === '' ? true : false;
};

const includeStringValue = (data: string, compare: string): boolean => {
  const INCLUDE_VALUE: boolean = data.trim().includes(compare.trim())
    ? true
    : false;
  return INCLUDE_VALUE;
};

const equalStringValue = (data: string, compare: string): boolean => {
  const COMPARE_VALUE: boolean =
    data.trim().localeCompare(compare.trim()) === 0 ? true : false;
  return COMPARE_VALUE;
};

const normalizarCodigo = (v: any): string => {
  return (v ?? '').toString().replace(/-/g, '').toUpperCase().trim();
};

const EXTENSIONES_IMAGEN = ['png', 'jpeg', 'jpg', 'gif'];

const obtenerExtensionArchivo = (valor?: string | null): string => {
  if (!valor) return '';
  const limpio = valor.split('?')[0].split('#')[0];
  const partes = limpio.split('.');
  return partes.length > 1 ? partes.pop()!.toLowerCase() : '';
};

/**
 * Determina si un archivo es una imagen a partir de su nombre (preferido) o, si no viene, de su URL.
 * Sin extensión detectable en ninguno de los dos, asume imagen (compatibilidad con llamadores que
 * nunca mandaron nombreArchivo/tipo y siempre subieron imágenes).
 */
const esImagenPorExtension = (nombreArchivo?: string | null, url?: string | null): boolean => {
  const extension = obtenerExtensionArchivo(nombreArchivo) || obtenerExtensionArchivo(url);
  return extension ? EXTENSIONES_IMAGEN.includes(extension) : true;
};

export {
  capitalizeFirstLetter,
  isString,
  getStringValue,
  getStringValueNoEmpty,
  includeStringValue,
  equalStringValue,
  isEmptyString,
  normalizarCodigo,
  esImagenPorExtension,
};
